module.exports = __webpack_public_path__ + "static/media/implicit-grant.4b1e87f7.jpg";